import { Button } from '@mantine/core';
import React, { useState } from 'react';
import { SavingIndicator } from '../../ui/SavingIndicator';
import { Flexer } from '../dashboard/elements/LayoutElements';

export const DevPage = () => {

    const [state, setState] = useState<'idle' | 'saving' | 'success' | 'error'>('idle');

    return <Flexer flex="column" gap="2" padding="10">
        <Flexer>
            <SavingIndicator state={state} />
        </Flexer>
        <Button.Group>
            <Button onClick={() => setState('idle')}>Idle</Button>
            <Button onClick={() => setState('saving')}>Saving</Button>
            <Button onClick={() => setState('success')}>Success</Button>
            <Button onClick={() => setState('error')}>Error</Button>
        </Button.Group>
    </Flexer>;

};
